/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateCustomerEphemeralKeyInput = {
  userId: string,
  stripeApiVersion: string,
};

export type EphemeralKey = {
  __typename: "EphemeralKey",
  id: string,
  object: string,
  associated_objects:  Array<EphemeralKeyAssociatedObject | null >,
  created: number,
  expires: number,
  livemode: boolean,
  secret: string,
};

export type EphemeralKeyAssociatedObject = {
  __typename: "EphemeralKeyAssociatedObject",
  id: string,
  type: string,
};

export type CreatePaymentIntent = {
  accountId: string,
  currency: Currency,
  amount: string,
  stripeApiVersion: string,
};

export enum Currency {
  USD = "USD",
  JPY = "JPY",
}


export type PaymentIntent = {
  __typename: "PaymentIntent",
  secret: string,
};

export type FillOrderInput = {
  orderTicketId: string,
  amount: string,
  bondPrice: string,
};

export type TradeTicketResult = {
  __typename: "TradeTicketResult",
  tradeTicketId: string,
};

export type CloseOrderInput = {
  orderTicketId: string,
  closedByUserId: string,
};

export type OrderTicket = {
  __typename: "OrderTicket",
  id: string,
  accountId: string,
  direction: OrderDirection,
  balanceAccountId: string,
  balanceAccount: BalanceAccount,
  bondId: string,
  bond: Bond,
  faceAmount: string,
  bondPrice: string,
  minimumFillSize: string,
  status: OrderStatus,
  statusLastChangeByUserId?: string | null,
  cancelReason?: CancelReason | null,
  isConfirmed: boolean,
  confirmedByTraderId?: string | null,
  confirmedAt?: string | null,
  closingTradeTicketId?: string | null,
  tradeTickets?: ModelTradeTicketConnection | null,
  appliedCommissionRate?: RateCommissionType | null,
  loadedYield: string,
  isImmediate?: boolean | null,
  timeInForce?: TimeInForce | null,
  expiresAt: string,
  createdAt: string,
  updatedAt: string,
};

export enum OrderDirection {
  Buy = "Buy",
  Sell = "Sell",
}


export type BalanceAccount = {
  __typename: "BalanceAccount",
  id: string,
  accountId: string,
  account: Account,
  currency?: Currency | null,
  bondId?: string | null,
  bond?: Bond | null,
  transactions?: ModelTransactionConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type Account = {
  __typename: "Account",
  id: string,
  owners: Array< string | null >,
  users?: ModelAccountHasUserConnection | null,
  balanceAccounts?: ModelBalanceAccountConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelAccountHasUserConnection = {
  __typename: "ModelAccountHasUserConnection",
  items:  Array<AccountHasUser | null >,
  nextToken?: string | null,
};

export type AccountHasUser = {
  __typename: "AccountHasUser",
  id: string,
  accountId: string,
  account: Account,
  userId: string,
  user: User,
  createdAt: string,
  updatedAt: string,
};

export type User = {
  __typename: "User",
  id: string,
  accounts?: ModelAccountHasUserConnection | null,
  stripeId?: string | null,
  favoriteBonds: Array< string >,
  createdAt: string,
  updatedAt: string,
};

export type ModelBalanceAccountConnection = {
  __typename: "ModelBalanceAccountConnection",
  items:  Array<BalanceAccount | null >,
  nextToken?: string | null,
};

export type Bond = {
  __typename: "Bond",
  id: string,
  // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
  cusip: string,
  isin: string,
  currency: Currency,
  issuerId: string,
  issuer: Issuer,
  couponPayment: string,
  outstandingAmount: string,
  minimumPiece: string,
  minimumIncrement: string,
  isSecRegisteredSecurity: boolean,
  ratings?: ModelBondRatingConnection | null,
  callDates?:  Array<BondCallDate | null > | null,
  paymentRank: string,
  couponType: CouponType,
  maturity: Maturity,
  bidAmount: string,
  offerAmount: string,
  benchmark?: Benchmark | null,
  spreadToBenchmark: string,
  accruedDays: string,
  accruedInterest: string,
  timezone: string,
  interpolatedCDRate: string,
  industry: string,
  esgScore: string,
  couponFrequency: string,
  makeWholeCall?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type Issuer = {
  __typename: "Issuer",
  id: string,
  name: string,
  ticker: string,
  bonds?: ModelBondConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelBondConnection = {
  __typename: "ModelBondConnection",
  items:  Array<Bond | null >,
  nextToken?: string | null,
};

export type ModelBondRatingConnection = {
  __typename: "ModelBondRatingConnection",
  items:  Array<BondRating | null >,
  nextToken?: string | null,
};

export type BondRating = {
  __typename: "BondRating",
  id: string,
  bondId: string,
  bond: Bond,
  ratingId: string,
  rating: Rating,
  watch?: RatingWatch | null,
  createdAt: string,
  updatedAt: string,
};

export type Rating = {
  __typename: "Rating",
  id: string,
  value: string,
  order: number,
  agencyId: string,
  agency: RatingAgency,
  bondRatings?: ModelBondRatingConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type RatingAgency = {
  __typename: "RatingAgency",
  id: string,
  name: string,
  ratings?: ModelRatingConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelRatingConnection = {
  __typename: "ModelRatingConnection",
  items:  Array<Rating | null >,
  nextToken?: string | null,
};

export enum RatingWatch {
  plus = "plus",
  minus = "minus",
}


export type BondCallDate = {
  __typename: "BondCallDate",
  price: string,
  callDate: string,
};

export enum CouponType {
  fixed = "fixed",
  variable = "variable",
}


export type Maturity = {
  __typename: "Maturity",
  date: string,
  maturityType: MaturityType,
  nextCallDate?: string | null,
  nextCallPrice?: string | null,
};

export enum MaturityType {
  callable = "callable",
  atMaturity = "atMaturity",
}


export enum Benchmark {
  B_1M = "B_1M",
  B_1Y = "B_1Y",
  B_2Y = "B_2Y",
  B_3Y = "B_3Y",
  B_5Y = "B_5Y",
  B_7Y = "B_7Y",
  B_10Y = "B_10Y",
  B_30Y = "B_30Y",
}


export type ModelTransactionConnection = {
  __typename: "ModelTransactionConnection",
  items:  Array<Transaction | null >,
  nextToken?: string | null,
};

export type Transaction = {
  __typename: "Transaction",
  id: string,
  accountId: string,
  previousTransactionId?: string | null,
  order: number,
  transactedAt: string,
  balanceAccountId: string,
  balanceAccount: BalanceAccount,
  source?: TransactionSource | null,
  type: TransactionType,
  amountChange: string,
  disponibleAmountChange: string,
  orderTicketId?: string | null,
  orderTicket?: OrderTicket | null,
  tradeTicketId?: string | null,
  tradeTicket?: TradeTicket | null,
  complementaryTransactionId?: string | null,
  balance: string,
  disponibleBalance: string,
  createdAt: string,
  updatedAt: string,
};

export enum TransactionSource {
  Stripe = "Stripe",
  Test = "Test",
}


export enum TransactionType {
  Deposit = "Deposit",
  Withdrawal = "Withdrawal",
  Trade = "Trade",
  OrderLock = "OrderLock",
}


export type TradeTicket = {
  __typename: "TradeTicket",
  id: string,
  accountId: string,
  orderTicketId: string,
  orderTicket: OrderTicket,
  amount: string,
  bondPrice: string,
  accruedDays: number,
  accruedInterest: string,
  tradeDate: string,
  settlementDate: string,
  closingOrderTickets?: ModelOrderTicketConnection | null,
  isClosed?: boolean | null,
  finalCommissionAmount: string,
  loadedYield: string,
  createdAt: string,
  updatedAt: string,
};

export type ModelOrderTicketConnection = {
  __typename: "ModelOrderTicketConnection",
  items:  Array<OrderTicket | null >,
  nextToken?: string | null,
};

export enum OrderStatus {
  Open = "Open",
  WaitingForTrader = "WaitingForTrader",
  Canceled = "Canceled",
  Closed = "Closed",
  CanceledByCustomer = "CanceledByCustomer",
  CanceledByTrader = "CanceledByTrader",
  CanceledAndReplaced = "CanceledAndReplaced",
  PendingCancelApproval = "PendingCancelApproval",
  PendingModifyApproval = "PendingModifyApproval",
  FillSubmittedToBroker = "FillSubmittedToBroker",
  FillAcknowledgedByBroker = "FillAcknowledgedByBroker",
  CancelSubmittedToBroker = "CancelSubmittedToBroker",
  ModifySubmittedToBroker = "ModifySubmittedToBroker",
  FullyFilled = "FullyFilled",
  Expired = "Expired",
}


export enum CancelReason {
  UserCancelled = "UserCancelled",
  InsufficientAmount = "InsufficientAmount",
}


export type ModelTradeTicketConnection = {
  __typename: "ModelTradeTicketConnection",
  items:  Array<TradeTicket | null >,
  nextToken?: string | null,
};

export type RateCommissionType = {
  __typename: "RateCommissionType",
  amount: string,
  rate: string,
};

export enum TimeInForce {
  CustomToday = "CustomToday",
  Immediate = "Immediate",
  CustomFuture = "CustomFuture",
}


export type AddTestMoneyInput = {
  accountId: string,
  currency?: Currency | null,
  amount: string,
};

export type CreateOrderTicketWithFundsReservationInput = {
  direction: OrderDirection,
  moneyBalanceAccountId: string,
  bondId: string,
  minimumFillSize: string,
  faceAmount: string,
  bondPrice: string,
  commission: RateCommissionInput,
  loadedYield: string,
  isImmediate: boolean,
  expiresAt?: string | null,
  closingTradeTicketId?: string | null,
};

export type RateCommissionInput = {
  amount: string,
  rate: string,
};

export type CreateAccountInput = {
  id?: string | null,
  owners: Array< string | null >,
};

export type ModelAccountConditionInput = {
  and?: Array< ModelAccountConditionInput | null > | null,
  or?: Array< ModelAccountConditionInput | null > | null,
  not?: ModelAccountConditionInput | null,
};

export type UpdateAccountInput = {
  id: string,
  owners?: Array< string | null > | null,
};

export type DeleteAccountInput = {
  id: string,
};

export type CreateAccountHasUserInput = {
  id?: string | null,
  accountId: string,
  userId: string,
};

export type ModelAccountHasUserConditionInput = {
  accountId?: ModelIDInput | null,
  and?: Array< ModelAccountHasUserConditionInput | null > | null,
  or?: Array< ModelAccountHasUserConditionInput | null > | null,
  not?: ModelAccountHasUserConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type UpdateAccountHasUserInput = {
  id: string,
  accountId?: string | null,
  userId?: string | null,
};

export type DeleteAccountHasUserInput = {
  id: string,
};

export type CreateUserInput = {
  id?: string | null,
  stripeId?: string | null,
  favoriteBonds: Array< string >,
};

export type ModelUserConditionInput = {
  stripeId?: ModelStringInput | null,
  favoriteBonds?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type UpdateUserInput = {
  id: string,
  stripeId?: string | null,
  favoriteBonds?: Array< string > | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateBalanceAccountInput = {
  id?: string | null,
  accountId: string,
  currency?: Currency | null,
  bondId?: string | null,
};

export type ModelBalanceAccountConditionInput = {
  currency?: ModelCurrencyInput | null,
  bondId?: ModelIDInput | null,
  and?: Array< ModelBalanceAccountConditionInput | null > | null,
  or?: Array< ModelBalanceAccountConditionInput | null > | null,
  not?: ModelBalanceAccountConditionInput | null,
};

export type ModelCurrencyInput = {
  eq?: Currency | null,
  ne?: Currency | null,
};

export type UpdateBalanceAccountInput = {
  id: string,
  accountId?: string | null,
  currency?: Currency | null,
  bondId?: string | null,
};

export type DeleteBalanceAccountInput = {
  id: string,
};

export type CreateTransactionInput = {
  id?: string | null,
  accountId: string,
  previousTransactionId?: string | null,
  order: number,
  transactedAt: string,
  balanceAccountId: string,
  source?: TransactionSource | null,
  type: TransactionType,
  amountChange: string,
  disponibleAmountChange: string,
  orderTicketId?: string | null,
  tradeTicketId?: string | null,
  complementaryTransactionId?: string | null,
  balance: string,
  disponibleBalance: string,
};

export type ModelTransactionConditionInput = {
  previousTransactionId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  transactedAt?: ModelStringInput | null,
  balanceAccountId?: ModelIDInput | null,
  source?: ModelTransactionSourceInput | null,
  type?: ModelTransactionTypeInput | null,
  amountChange?: ModelStringInput | null,
  disponibleAmountChange?: ModelStringInput | null,
  orderTicketId?: ModelIDInput | null,
  tradeTicketId?: ModelIDInput | null,
  complementaryTransactionId?: ModelIDInput | null,
  balance?: ModelStringInput | null,
  disponibleBalance?: ModelStringInput | null,
  and?: Array< ModelTransactionConditionInput | null > | null,
  or?: Array< ModelTransactionConditionInput | null > | null,
  not?: ModelTransactionConditionInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelTransactionSourceInput = {
  eq?: TransactionSource | null,
  ne?: TransactionSource | null,
};

export type ModelTransactionTypeInput = {
  eq?: TransactionType | null,
  ne?: TransactionType | null,
};

export type UpdateTransactionInput = {
  id: string,
  accountId?: string | null,
  previousTransactionId?: string | null,
  order?: number | null,
  transactedAt?: string | null,
  balanceAccountId?: string | null,
  source?: TransactionSource | null,
  type?: TransactionType | null,
  amountChange?: string | null,
  disponibleAmountChange?: string | null,
  orderTicketId?: string | null,
  tradeTicketId?: string | null,
  complementaryTransactionId?: string | null,
  balance?: string | null,
  disponibleBalance?: string | null,
};

export type DeleteTransactionInput = {
  id: string,
};

export type CreateTradeTicketInput = {
  id?: string | null,
  accountId: string,
  orderTicketId: string,
  amount: string,
  bondPrice: string,
  accruedDays: number,
  accruedInterest: string,
  tradeDate: string,
  settlementDate: string,
  isClosed?: boolean | null,
  finalCommissionAmount: string,
  loadedYield: string,
};

export type ModelTradeTicketConditionInput = {
  orderTicketId?: ModelIDInput | null,
  amount?: ModelStringInput | null,
  bondPrice?: ModelStringInput | null,
  accruedDays?: ModelIntInput | null,
  accruedInterest?: ModelStringInput | null,
  tradeDate?: ModelStringInput | null,
  settlementDate?: ModelStringInput | null,
  isClosed?: ModelBooleanInput | null,
  finalCommissionAmount?: ModelStringInput | null,
  loadedYield?: ModelStringInput | null,
  and?: Array< ModelTradeTicketConditionInput | null > | null,
  or?: Array< ModelTradeTicketConditionInput | null > | null,
  not?: ModelTradeTicketConditionInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdateTradeTicketInput = {
  id: string,
  accountId?: string | null,
  orderTicketId?: string | null,
  amount?: string | null,
  bondPrice?: string | null,
  accruedDays?: number | null,
  accruedInterest?: string | null,
  tradeDate?: string | null,
  settlementDate?: string | null,
  isClosed?: boolean | null,
  finalCommissionAmount?: string | null,
  loadedYield?: string | null,
};

export type DeleteTradeTicketInput = {
  id: string,
};

export type CreateOrderTicketInput = {
  id?: string | null,
  accountId: string,
  direction: OrderDirection,
  balanceAccountId: string,
  bondId: string,
  faceAmount: string,
  bondPrice: string,
  minimumFillSize: string,
  status: OrderStatus,
  statusLastChangeByUserId?: string | null,
  cancelReason?: CancelReason | null,
  isConfirmed: boolean,
  confirmedByTraderId?: string | null,
  confirmedAt?: string | null,
  closingTradeTicketId?: string | null,
  appliedCommissionRate?: RateCommissionTypeInput | null,
  loadedYield: string,
  isImmediate?: boolean | null,
  timeInForce?: TimeInForce | null,
  expiresAt: string,
};

export type RateCommissionTypeInput = {
  amount: string,
  rate: string,
};

export type ModelOrderTicketConditionInput = {
  direction?: ModelOrderDirectionInput | null,
  balanceAccountId?: ModelIDInput | null,
  bondId?: ModelIDInput | null,
  faceAmount?: ModelStringInput | null,
  bondPrice?: ModelStringInput | null,
  minimumFillSize?: ModelStringInput | null,
  status?: ModelOrderStatusInput | null,
  statusLastChangeByUserId?: ModelIDInput | null,
  cancelReason?: ModelCancelReasonInput | null,
  isConfirmed?: ModelBooleanInput | null,
  confirmedByTraderId?: ModelIDInput | null,
  confirmedAt?: ModelStringInput | null,
  closingTradeTicketId?: ModelIDInput | null,
  loadedYield?: ModelStringInput | null,
  isImmediate?: ModelBooleanInput | null,
  timeInForce?: ModelTimeInForceInput | null,
  expiresAt?: ModelStringInput | null,
  and?: Array< ModelOrderTicketConditionInput | null > | null,
  or?: Array< ModelOrderTicketConditionInput | null > | null,
  not?: ModelOrderTicketConditionInput | null,
};

export type ModelOrderDirectionInput = {
  eq?: OrderDirection | null,
  ne?: OrderDirection | null,
};

export type ModelOrderStatusInput = {
  eq?: OrderStatus | null,
  ne?: OrderStatus | null,
};

export type ModelCancelReasonInput = {
  eq?: CancelReason | null,
  ne?: CancelReason | null,
};

export type ModelTimeInForceInput = {
  eq?: TimeInForce | null,
  ne?: TimeInForce | null,
};

export type UpdateOrderTicketInput = {
  id: string,
  accountId?: string | null,
  direction?: OrderDirection | null,
  balanceAccountId?: string | null,
  bondId?: string | null,
  faceAmount?: string | null,
  bondPrice?: string | null,
  minimumFillSize?: string | null,
  status?: OrderStatus | null,
  statusLastChangeByUserId?: string | null,
  cancelReason?: CancelReason | null,
  isConfirmed?: boolean | null,
  confirmedByTraderId?: string | null,
  confirmedAt?: string | null,
  closingTradeTicketId?: string | null,
  appliedCommissionRate?: RateCommissionTypeInput | null,
  loadedYield?: string | null,
  isImmediate?: boolean | null,
  timeInForce?: TimeInForce | null,
  expiresAt?: string | null,
};

export type DeleteOrderTicketInput = {
  id: string,
};

export type CreateRateCommissionInput = {
  id?: string | null,
  currency: Currency,
  amount: string,
  rate: string,
};

export type ModelRateCommissionConditionInput = {
  currency?: ModelCurrencyInput | null,
  amount?: ModelStringInput | null,
  rate?: ModelStringInput | null,
  and?: Array< ModelRateCommissionConditionInput | null > | null,
  or?: Array< ModelRateCommissionConditionInput | null > | null,
  not?: ModelRateCommissionConditionInput | null,
};

export type RateCommission = {
  __typename: "RateCommission",
  id: string,
  currency: Currency,
  amount: string,
  rate: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateRateCommissionInput = {
  id: string,
  currency?: Currency | null,
  amount?: string | null,
  rate?: string | null,
};

export type DeleteRateCommissionInput = {
  id: string,
};

export type CreateBondInput = {
  id?: string | null,
  cusip: string,
  isin: string,
  currency: Currency,
  issuerId: string,
  couponPayment: string,
  outstandingAmount: string,
  minimumPiece: string,
  minimumIncrement: string,
  isSecRegisteredSecurity: boolean,
  callDates?: Array< BondCallDateInput | null > | null,
  paymentRank: string,
  couponType: CouponType,
  maturity: MaturityInput,
  bidAmount: string,
  offerAmount: string,
  benchmark?: Benchmark | null,
  spreadToBenchmark: string,
  accruedDays: string,
  accruedInterest: string,
  timezone: string,
  interpolatedCDRate: string,
  industry: string,
  esgScore: string,
  couponFrequency: string,
  makeWholeCall?: string | null,
};

export type BondCallDateInput = {
  price: string,
  callDate: string,
};

export type MaturityInput = {
  date: string,
  maturityType: MaturityType,
  nextCallDate?: string | null,
  nextCallPrice?: string | null,
};

export type ModelBondConditionInput = {
  cusip?: ModelStringInput | null,
  isin?: ModelStringInput | null,
  currency?: ModelCurrencyInput | null,
  issuerId?: ModelIDInput | null,
  couponPayment?: ModelStringInput | null,
  outstandingAmount?: ModelStringInput | null,
  minimumPiece?: ModelStringInput | null,
  minimumIncrement?: ModelStringInput | null,
  isSecRegisteredSecurity?: ModelBooleanInput | null,
  paymentRank?: ModelStringInput | null,
  couponType?: ModelCouponTypeInput | null,
  bidAmount?: ModelStringInput | null,
  offerAmount?: ModelStringInput | null,
  benchmark?: ModelBenchmarkInput | null,
  spreadToBenchmark?: ModelStringInput | null,
  accruedDays?: ModelStringInput | null,
  accruedInterest?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  interpolatedCDRate?: ModelStringInput | null,
  industry?: ModelStringInput | null,
  esgScore?: ModelStringInput | null,
  couponFrequency?: ModelStringInput | null,
  makeWholeCall?: ModelStringInput | null,
  and?: Array< ModelBondConditionInput | null > | null,
  or?: Array< ModelBondConditionInput | null > | null,
  not?: ModelBondConditionInput | null,
};

export type ModelCouponTypeInput = {
  eq?: CouponType | null,
  ne?: CouponType | null,
};

export type ModelBenchmarkInput = {
  eq?: Benchmark | null,
  ne?: Benchmark | null,
};

export type UpdateBondInput = {
  id: string,
  cusip?: string | null,
  isin?: string | null,
  currency?: Currency | null,
  issuerId?: string | null,
  couponPayment?: string | null,
  outstandingAmount?: string | null,
  minimumPiece?: string | null,
  minimumIncrement?: string | null,
  isSecRegisteredSecurity?: boolean | null,
  callDates?: Array< BondCallDateInput | null > | null,
  paymentRank?: string | null,
  couponType?: CouponType | null,
  maturity?: MaturityInput | null,
  bidAmount?: string | null,
  offerAmount?: string | null,
  benchmark?: Benchmark | null,
  spreadToBenchmark?: string | null,
  accruedDays?: string | null,
  accruedInterest?: string | null,
  timezone?: string | null,
  interpolatedCDRate?: string | null,
  industry?: string | null,
  esgScore?: string | null,
  couponFrequency?: string | null,
  makeWholeCall?: string | null,
};

export type DeleteBondInput = {
  id: string,
};

export type CreateIssuerInput = {
  id?: string | null,
  name: string,
  ticker: string,
};

export type ModelIssuerConditionInput = {
  name?: ModelStringInput | null,
  ticker?: ModelStringInput | null,
  and?: Array< ModelIssuerConditionInput | null > | null,
  or?: Array< ModelIssuerConditionInput | null > | null,
  not?: ModelIssuerConditionInput | null,
};

export type UpdateIssuerInput = {
  id: string,
  name?: string | null,
  ticker?: string | null,
};

export type DeleteIssuerInput = {
  id: string,
};

export type CreateBondRatingInput = {
  id?: string | null,
  bondId: string,
  ratingId: string,
  watch?: RatingWatch | null,
};

export type ModelBondRatingConditionInput = {
  bondId?: ModelIDInput | null,
  ratingId?: ModelIDInput | null,
  watch?: ModelRatingWatchInput | null,
  and?: Array< ModelBondRatingConditionInput | null > | null,
  or?: Array< ModelBondRatingConditionInput | null > | null,
  not?: ModelBondRatingConditionInput | null,
};

export type ModelRatingWatchInput = {
  eq?: RatingWatch | null,
  ne?: RatingWatch | null,
};

export type UpdateBondRatingInput = {
  id: string,
  bondId?: string | null,
  ratingId?: string | null,
  watch?: RatingWatch | null,
};

export type DeleteBondRatingInput = {
  id: string,
};

export type CreateRatingInput = {
  id?: string | null,
  value: string,
  order: number,
  agencyId: string,
};

export type ModelRatingConditionInput = {
  value?: ModelStringInput | null,
  order?: ModelIntInput | null,
  agencyId?: ModelIDInput | null,
  and?: Array< ModelRatingConditionInput | null > | null,
  or?: Array< ModelRatingConditionInput | null > | null,
  not?: ModelRatingConditionInput | null,
};

export type UpdateRatingInput = {
  id: string,
  value?: string | null,
  order?: number | null,
  agencyId?: string | null,
};

export type DeleteRatingInput = {
  id: string,
};

export type CreateRatingAgencyInput = {
  id?: string | null,
  name: string,
};

export type ModelRatingAgencyConditionInput = {
  name?: ModelStringInput | null,
  and?: Array< ModelRatingAgencyConditionInput | null > | null,
  or?: Array< ModelRatingAgencyConditionInput | null > | null,
  not?: ModelRatingAgencyConditionInput | null,
};

export type UpdateRatingAgencyInput = {
  id: string,
  name?: string | null,
};

export type DeleteRatingAgencyInput = {
  id: string,
};

export type BondPriceResponse = {
  __typename: "BondPriceResponse",
  updatedAt: string,
  bondPrices?:  Array<BondPrice | null > | null,
};

export type BondPrice = {
  __typename: "BondPrice",
  bondId: string,
  bidPrice: string,
  askPrice: string,
  gSpread: string,
  bidGSpread: string,
  yieldAndSpreadBondYield: string,
  bidYield: string,
};

export type BondSettlementDateInput = {
  tradedAt: string,
};

export type BondSettlementDateResponse = {
  __typename: "BondSettlementDateResponse",
  settledAt: string,
};

export type ModelAccountFilterInput = {
  id?: ModelIDInput | null,
  owners?: ModelStringInput | null,
  and?: Array< ModelAccountFilterInput | null > | null,
  or?: Array< ModelAccountFilterInput | null > | null,
  not?: ModelAccountFilterInput | null,
};

export type ModelAccountConnection = {
  __typename: "ModelAccountConnection",
  items:  Array<Account | null >,
  nextToken?: string | null,
};

export type ModelAccountHasUserFilterInput = {
  id?: ModelIDInput | null,
  accountId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  and?: Array< ModelAccountHasUserFilterInput | null > | null,
  or?: Array< ModelAccountHasUserFilterInput | null > | null,
  not?: ModelAccountHasUserFilterInput | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  stripeId?: ModelStringInput | null,
  favoriteBonds?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelBalanceAccountFilterInput = {
  id?: ModelIDInput | null,
  accountId?: ModelIDInput | null,
  currency?: ModelCurrencyInput | null,
  bondId?: ModelIDInput | null,
  and?: Array< ModelBalanceAccountFilterInput | null > | null,
  or?: Array< ModelBalanceAccountFilterInput | null > | null,
  not?: ModelBalanceAccountFilterInput | null,
};

export type ModelTransactionFilterInput = {
  id?: ModelIDInput | null,
  accountId?: ModelIDInput | null,
  previousTransactionId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  transactedAt?: ModelStringInput | null,
  balanceAccountId?: ModelIDInput | null,
  source?: ModelTransactionSourceInput | null,
  type?: ModelTransactionTypeInput | null,
  amountChange?: ModelStringInput | null,
  disponibleAmountChange?: ModelStringInput | null,
  orderTicketId?: ModelIDInput | null,
  tradeTicketId?: ModelIDInput | null,
  complementaryTransactionId?: ModelIDInput | null,
  balance?: ModelStringInput | null,
  disponibleBalance?: ModelStringInput | null,
  and?: Array< ModelTransactionFilterInput | null > | null,
  or?: Array< ModelTransactionFilterInput | null > | null,
  not?: ModelTransactionFilterInput | null,
};

export type ModelTradeTicketFilterInput = {
  id?: ModelIDInput | null,
  accountId?: ModelIDInput | null,
  orderTicketId?: ModelIDInput | null,
  amount?: ModelStringInput | null,
  bondPrice?: ModelStringInput | null,
  accruedDays?: ModelIntInput | null,
  accruedInterest?: ModelStringInput | null,
  tradeDate?: ModelStringInput | null,
  settlementDate?: ModelStringInput | null,
  isClosed?: ModelBooleanInput | null,
  finalCommissionAmount?: ModelStringInput | null,
  loadedYield?: ModelStringInput | null,
  and?: Array< ModelTradeTicketFilterInput | null > | null,
  or?: Array< ModelTradeTicketFilterInput | null > | null,
  not?: ModelTradeTicketFilterInput | null,
};

export type ModelOrderTicketFilterInput = {
  id?: ModelIDInput | null,
  accountId?: ModelIDInput | null,
  direction?: ModelOrderDirectionInput | null,
  balanceAccountId?: ModelIDInput | null,
  bondId?: ModelIDInput | null,
  faceAmount?: ModelStringInput | null,
  bondPrice?: ModelStringInput | null,
  minimumFillSize?: ModelStringInput | null,
  status?: ModelOrderStatusInput | null,
  statusLastChangeByUserId?: ModelIDInput | null,
  cancelReason?: ModelCancelReasonInput | null,
  isConfirmed?: ModelBooleanInput | null,
  confirmedByTraderId?: ModelIDInput | null,
  confirmedAt?: ModelStringInput | null,
  closingTradeTicketId?: ModelIDInput | null,
  loadedYield?: ModelStringInput | null,
  isImmediate?: ModelBooleanInput | null,
  timeInForce?: ModelTimeInForceInput | null,
  expiresAt?: ModelStringInput | null,
  and?: Array< ModelOrderTicketFilterInput | null > | null,
  or?: Array< ModelOrderTicketFilterInput | null > | null,
  not?: ModelOrderTicketFilterInput | null,
};

export type ModelRateCommissionFilterInput = {
  currency?: ModelCurrencyInput | null,
  amount?: ModelStringInput | null,
  rate?: ModelStringInput | null,
  and?: Array< ModelRateCommissionFilterInput | null > | null,
  or?: Array< ModelRateCommissionFilterInput | null > | null,
  not?: ModelRateCommissionFilterInput | null,
};

export type ModelRateCommissionConnection = {
  __typename: "ModelRateCommissionConnection",
  items:  Array<RateCommission | null >,
  nextToken?: string | null,
};

export type ModelBondFilterInput = {
  id?: ModelIDInput | null,
  cusip?: ModelStringInput | null,
  isin?: ModelStringInput | null,
  currency?: ModelCurrencyInput | null,
  issuerId?: ModelIDInput | null,
  couponPayment?: ModelStringInput | null,
  outstandingAmount?: ModelStringInput | null,
  minimumPiece?: ModelStringInput | null,
  minimumIncrement?: ModelStringInput | null,
  isSecRegisteredSecurity?: ModelBooleanInput | null,
  paymentRank?: ModelStringInput | null,
  couponType?: ModelCouponTypeInput | null,
  bidAmount?: ModelStringInput | null,
  offerAmount?: ModelStringInput | null,
  benchmark?: ModelBenchmarkInput | null,
  spreadToBenchmark?: ModelStringInput | null,
  accruedDays?: ModelStringInput | null,
  accruedInterest?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  interpolatedCDRate?: ModelStringInput | null,
  industry?: ModelStringInput | null,
  esgScore?: ModelStringInput | null,
  couponFrequency?: ModelStringInput | null,
  makeWholeCall?: ModelStringInput | null,
  and?: Array< ModelBondFilterInput | null > | null,
  or?: Array< ModelBondFilterInput | null > | null,
  not?: ModelBondFilterInput | null,
};

export type ModelIssuerFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  ticker?: ModelStringInput | null,
  and?: Array< ModelIssuerFilterInput | null > | null,
  or?: Array< ModelIssuerFilterInput | null > | null,
  not?: ModelIssuerFilterInput | null,
};

export type ModelIssuerConnection = {
  __typename: "ModelIssuerConnection",
  items:  Array<Issuer | null >,
  nextToken?: string | null,
};

export type ModelBondRatingFilterInput = {
  id?: ModelIDInput | null,
  bondId?: ModelIDInput | null,
  ratingId?: ModelIDInput | null,
  watch?: ModelRatingWatchInput | null,
  and?: Array< ModelBondRatingFilterInput | null > | null,
  or?: Array< ModelBondRatingFilterInput | null > | null,
  not?: ModelBondRatingFilterInput | null,
};

export type ModelRatingFilterInput = {
  id?: ModelIDInput | null,
  value?: ModelStringInput | null,
  order?: ModelIntInput | null,
  agencyId?: ModelIDInput | null,
  and?: Array< ModelRatingFilterInput | null > | null,
  or?: Array< ModelRatingFilterInput | null > | null,
  not?: ModelRatingFilterInput | null,
};

export type ModelRatingAgencyFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelRatingAgencyFilterInput | null > | null,
  or?: Array< ModelRatingAgencyFilterInput | null > | null,
  not?: ModelRatingAgencyFilterInput | null,
};

export type ModelRatingAgencyConnection = {
  __typename: "ModelRatingAgencyConnection",
  items:  Array<RatingAgency | null >,
  nextToken?: string | null,
};

export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type CreateCustomerEphemeralKeyMutationVariables = {
  input: CreateCustomerEphemeralKeyInput,
};

export type CreateCustomerEphemeralKeyMutation = {
  createCustomerEphemeralKey?:  {
    __typename: "EphemeralKey",
    id: string,
    object: string,
    associated_objects:  Array< {
      __typename: "EphemeralKeyAssociatedObject",
      id: string,
      type: string,
    } | null >,
    created: number,
    expires: number,
    livemode: boolean,
    secret: string,
  } | null,
};

export type CreatePaymentIntentMutationVariables = {
  input: CreatePaymentIntent,
};

export type CreatePaymentIntentMutation = {
  createPaymentIntent?:  {
    __typename: "PaymentIntent",
    secret: string,
  } | null,
};

export type FillOrderMutationVariables = {
  input: FillOrderInput,
};

export type FillOrderMutation = {
  fillOrder?:  {
    __typename: "TradeTicketResult",
    tradeTicketId: string,
  } | null,
};

export type CloseOrderMutationVariables = {
  input: CloseOrderInput,
};

export type CloseOrderMutation = {
  closeOrder?:  {
    __typename: "OrderTicket",
    id: string,
    accountId: string,
    direction: OrderDirection,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    faceAmount: string,
    bondPrice: string,
    minimumFillSize: string,
    status: OrderStatus,
    statusLastChangeByUserId?: string | null,
    cancelReason?: CancelReason | null,
    isConfirmed: boolean,
    confirmedByTraderId?: string | null,
    confirmedAt?: string | null,
    closingTradeTicketId?: string | null,
    tradeTickets?:  {
      __typename: "ModelTradeTicketConnection",
      nextToken?: string | null,
    } | null,
    appliedCommissionRate?:  {
      __typename: "RateCommissionType",
      amount: string,
      rate: string,
    } | null,
    loadedYield: string,
    isImmediate?: boolean | null,
    timeInForce?: TimeInForce | null,
    expiresAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type AddTestMoneyMutationVariables = {
  input: AddTestMoneyInput,
};

export type AddTestMoneyMutation = {
  addTestMoney?:  {
    __typename: "Transaction",
    id: string,
    accountId: string,
    previousTransactionId?: string | null,
    order: number,
    transactedAt: string,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    source?: TransactionSource | null,
    type: TransactionType,
    amountChange: string,
    disponibleAmountChange: string,
    orderTicketId?: string | null,
    orderTicket?:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    tradeTicketId?: string | null,
    tradeTicket?:  {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    complementaryTransactionId?: string | null,
    balance: string,
    disponibleBalance: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrderTicketWithFundsReservationMutationVariables = {
  input: CreateOrderTicketWithFundsReservationInput,
};

export type CreateOrderTicketWithFundsReservationMutation = {
  createOrderTicketWithFundsReservation?:  {
    __typename: "OrderTicket",
    id: string,
    accountId: string,
    direction: OrderDirection,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    faceAmount: string,
    bondPrice: string,
    minimumFillSize: string,
    status: OrderStatus,
    statusLastChangeByUserId?: string | null,
    cancelReason?: CancelReason | null,
    isConfirmed: boolean,
    confirmedByTraderId?: string | null,
    confirmedAt?: string | null,
    closingTradeTicketId?: string | null,
    tradeTickets?:  {
      __typename: "ModelTradeTicketConnection",
      nextToken?: string | null,
    } | null,
    appliedCommissionRate?:  {
      __typename: "RateCommissionType",
      amount: string,
      rate: string,
    } | null,
    loadedYield: string,
    isImmediate?: boolean | null,
    timeInForce?: TimeInForce | null,
    expiresAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAccountMutationVariables = {
  input: CreateAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type CreateAccountMutation = {
  createAccount?:  {
    __typename: "Account",
    id: string,
    owners: Array< string | null >,
    users?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    balanceAccounts?:  {
      __typename: "ModelBalanceAccountConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAccountMutationVariables = {
  input: UpdateAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type UpdateAccountMutation = {
  updateAccount?:  {
    __typename: "Account",
    id: string,
    owners: Array< string | null >,
    users?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    balanceAccounts?:  {
      __typename: "ModelBalanceAccountConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAccountMutationVariables = {
  input: DeleteAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type DeleteAccountMutation = {
  deleteAccount?:  {
    __typename: "Account",
    id: string,
    owners: Array< string | null >,
    users?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    balanceAccounts?:  {
      __typename: "ModelBalanceAccountConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAccountHasUserMutationVariables = {
  input: CreateAccountHasUserInput,
  condition?: ModelAccountHasUserConditionInput | null,
};

export type CreateAccountHasUserMutation = {
  createAccountHasUser?:  {
    __typename: "AccountHasUser",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    userId: string,
    user:  {
      __typename: "User",
      id: string,
      stripeId?: string | null,
      favoriteBonds: Array< string >,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAccountHasUserMutationVariables = {
  input: UpdateAccountHasUserInput,
  condition?: ModelAccountHasUserConditionInput | null,
};

export type UpdateAccountHasUserMutation = {
  updateAccountHasUser?:  {
    __typename: "AccountHasUser",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    userId: string,
    user:  {
      __typename: "User",
      id: string,
      stripeId?: string | null,
      favoriteBonds: Array< string >,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAccountHasUserMutationVariables = {
  input: DeleteAccountHasUserInput,
  condition?: ModelAccountHasUserConditionInput | null,
};

export type DeleteAccountHasUserMutation = {
  deleteAccountHasUser?:  {
    __typename: "AccountHasUser",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    userId: string,
    user:  {
      __typename: "User",
      id: string,
      stripeId?: string | null,
      favoriteBonds: Array< string >,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    accounts?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    stripeId?: string | null,
    favoriteBonds: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    accounts?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    stripeId?: string | null,
    favoriteBonds: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    accounts?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    stripeId?: string | null,
    favoriteBonds: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBalanceAccountMutationVariables = {
  input: CreateBalanceAccountInput,
  condition?: ModelBalanceAccountConditionInput | null,
};

export type CreateBalanceAccountMutation = {
  createBalanceAccount?:  {
    __typename: "BalanceAccount",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    currency?: Currency | null,
    bondId?: string | null,
    bond?:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactions?:  {
      __typename: "ModelTransactionConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBalanceAccountMutationVariables = {
  input: UpdateBalanceAccountInput,
  condition?: ModelBalanceAccountConditionInput | null,
};

export type UpdateBalanceAccountMutation = {
  updateBalanceAccount?:  {
    __typename: "BalanceAccount",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    currency?: Currency | null,
    bondId?: string | null,
    bond?:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactions?:  {
      __typename: "ModelTransactionConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBalanceAccountMutationVariables = {
  input: DeleteBalanceAccountInput,
  condition?: ModelBalanceAccountConditionInput | null,
};

export type DeleteBalanceAccountMutation = {
  deleteBalanceAccount?:  {
    __typename: "BalanceAccount",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    currency?: Currency | null,
    bondId?: string | null,
    bond?:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactions?:  {
      __typename: "ModelTransactionConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTransactionMutationVariables = {
  input: CreateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type CreateTransactionMutation = {
  createTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountId: string,
    previousTransactionId?: string | null,
    order: number,
    transactedAt: string,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    source?: TransactionSource | null,
    type: TransactionType,
    amountChange: string,
    disponibleAmountChange: string,
    orderTicketId?: string | null,
    orderTicket?:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    tradeTicketId?: string | null,
    tradeTicket?:  {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    complementaryTransactionId?: string | null,
    balance: string,
    disponibleBalance: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTransactionMutationVariables = {
  input: UpdateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type UpdateTransactionMutation = {
  updateTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountId: string,
    previousTransactionId?: string | null,
    order: number,
    transactedAt: string,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    source?: TransactionSource | null,
    type: TransactionType,
    amountChange: string,
    disponibleAmountChange: string,
    orderTicketId?: string | null,
    orderTicket?:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    tradeTicketId?: string | null,
    tradeTicket?:  {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    complementaryTransactionId?: string | null,
    balance: string,
    disponibleBalance: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTransactionMutationVariables = {
  input: DeleteTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type DeleteTransactionMutation = {
  deleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountId: string,
    previousTransactionId?: string | null,
    order: number,
    transactedAt: string,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    source?: TransactionSource | null,
    type: TransactionType,
    amountChange: string,
    disponibleAmountChange: string,
    orderTicketId?: string | null,
    orderTicket?:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    tradeTicketId?: string | null,
    tradeTicket?:  {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    complementaryTransactionId?: string | null,
    balance: string,
    disponibleBalance: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTradeTicketMutationVariables = {
  input: CreateTradeTicketInput,
  condition?: ModelTradeTicketConditionInput | null,
};

export type CreateTradeTicketMutation = {
  createTradeTicket?:  {
    __typename: "TradeTicket",
    id: string,
    accountId: string,
    orderTicketId: string,
    orderTicket:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    },
    amount: string,
    bondPrice: string,
    accruedDays: number,
    accruedInterest: string,
    tradeDate: string,
    settlementDate: string,
    closingOrderTickets?:  {
      __typename: "ModelOrderTicketConnection",
      nextToken?: string | null,
    } | null,
    isClosed?: boolean | null,
    finalCommissionAmount: string,
    loadedYield: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTradeTicketMutationVariables = {
  input: UpdateTradeTicketInput,
  condition?: ModelTradeTicketConditionInput | null,
};

export type UpdateTradeTicketMutation = {
  updateTradeTicket?:  {
    __typename: "TradeTicket",
    id: string,
    accountId: string,
    orderTicketId: string,
    orderTicket:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    },
    amount: string,
    bondPrice: string,
    accruedDays: number,
    accruedInterest: string,
    tradeDate: string,
    settlementDate: string,
    closingOrderTickets?:  {
      __typename: "ModelOrderTicketConnection",
      nextToken?: string | null,
    } | null,
    isClosed?: boolean | null,
    finalCommissionAmount: string,
    loadedYield: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTradeTicketMutationVariables = {
  input: DeleteTradeTicketInput,
  condition?: ModelTradeTicketConditionInput | null,
};

export type DeleteTradeTicketMutation = {
  deleteTradeTicket?:  {
    __typename: "TradeTicket",
    id: string,
    accountId: string,
    orderTicketId: string,
    orderTicket:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    },
    amount: string,
    bondPrice: string,
    accruedDays: number,
    accruedInterest: string,
    tradeDate: string,
    settlementDate: string,
    closingOrderTickets?:  {
      __typename: "ModelOrderTicketConnection",
      nextToken?: string | null,
    } | null,
    isClosed?: boolean | null,
    finalCommissionAmount: string,
    loadedYield: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrderTicketMutationVariables = {
  input: CreateOrderTicketInput,
  condition?: ModelOrderTicketConditionInput | null,
};

export type CreateOrderTicketMutation = {
  createOrderTicket?:  {
    __typename: "OrderTicket",
    id: string,
    accountId: string,
    direction: OrderDirection,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    faceAmount: string,
    bondPrice: string,
    minimumFillSize: string,
    status: OrderStatus,
    statusLastChangeByUserId?: string | null,
    cancelReason?: CancelReason | null,
    isConfirmed: boolean,
    confirmedByTraderId?: string | null,
    confirmedAt?: string | null,
    closingTradeTicketId?: string | null,
    tradeTickets?:  {
      __typename: "ModelTradeTicketConnection",
      nextToken?: string | null,
    } | null,
    appliedCommissionRate?:  {
      __typename: "RateCommissionType",
      amount: string,
      rate: string,
    } | null,
    loadedYield: string,
    isImmediate?: boolean | null,
    timeInForce?: TimeInForce | null,
    expiresAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrderTicketMutationVariables = {
  input: UpdateOrderTicketInput,
  condition?: ModelOrderTicketConditionInput | null,
};

export type UpdateOrderTicketMutation = {
  updateOrderTicket?:  {
    __typename: "OrderTicket",
    id: string,
    accountId: string,
    direction: OrderDirection,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    faceAmount: string,
    bondPrice: string,
    minimumFillSize: string,
    status: OrderStatus,
    statusLastChangeByUserId?: string | null,
    cancelReason?: CancelReason | null,
    isConfirmed: boolean,
    confirmedByTraderId?: string | null,
    confirmedAt?: string | null,
    closingTradeTicketId?: string | null,
    tradeTickets?:  {
      __typename: "ModelTradeTicketConnection",
      nextToken?: string | null,
    } | null,
    appliedCommissionRate?:  {
      __typename: "RateCommissionType",
      amount: string,
      rate: string,
    } | null,
    loadedYield: string,
    isImmediate?: boolean | null,
    timeInForce?: TimeInForce | null,
    expiresAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrderTicketMutationVariables = {
  input: DeleteOrderTicketInput,
  condition?: ModelOrderTicketConditionInput | null,
};

export type DeleteOrderTicketMutation = {
  deleteOrderTicket?:  {
    __typename: "OrderTicket",
    id: string,
    accountId: string,
    direction: OrderDirection,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    faceAmount: string,
    bondPrice: string,
    minimumFillSize: string,
    status: OrderStatus,
    statusLastChangeByUserId?: string | null,
    cancelReason?: CancelReason | null,
    isConfirmed: boolean,
    confirmedByTraderId?: string | null,
    confirmedAt?: string | null,
    closingTradeTicketId?: string | null,
    tradeTickets?:  {
      __typename: "ModelTradeTicketConnection",
      nextToken?: string | null,
    } | null,
    appliedCommissionRate?:  {
      __typename: "RateCommissionType",
      amount: string,
      rate: string,
    } | null,
    loadedYield: string,
    isImmediate?: boolean | null,
    timeInForce?: TimeInForce | null,
    expiresAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRateCommissionMutationVariables = {
  input: CreateRateCommissionInput,
  condition?: ModelRateCommissionConditionInput | null,
};

export type CreateRateCommissionMutation = {
  createRateCommission?:  {
    __typename: "RateCommission",
    id: string,
    currency: Currency,
    amount: string,
    rate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRateCommissionMutationVariables = {
  input: UpdateRateCommissionInput,
  condition?: ModelRateCommissionConditionInput | null,
};

export type UpdateRateCommissionMutation = {
  updateRateCommission?:  {
    __typename: "RateCommission",
    id: string,
    currency: Currency,
    amount: string,
    rate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRateCommissionMutationVariables = {
  input: DeleteRateCommissionInput,
  condition?: ModelRateCommissionConditionInput | null,
};

export type DeleteRateCommissionMutation = {
  deleteRateCommission?:  {
    __typename: "RateCommission",
    id: string,
    currency: Currency,
    amount: string,
    rate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBondMutationVariables = {
  input: CreateBondInput,
  condition?: ModelBondConditionInput | null,
};

export type CreateBondMutation = {
  createBond?:  {
    __typename: "Bond",
    id: string,
    // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
    cusip: string,
    isin: string,
    currency: Currency,
    issuerId: string,
    issuer:  {
      __typename: "Issuer",
      id: string,
      name: string,
      ticker: string,
      createdAt: string,
      updatedAt: string,
    },
    couponPayment: string,
    outstandingAmount: string,
    minimumPiece: string,
    minimumIncrement: string,
    isSecRegisteredSecurity: boolean,
    ratings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    callDates?:  Array< {
      __typename: "BondCallDate",
      price: string,
      callDate: string,
    } | null > | null,
    paymentRank: string,
    couponType: CouponType,
    maturity:  {
      __typename: "Maturity",
      date: string,
      maturityType: MaturityType,
      nextCallDate?: string | null,
      nextCallPrice?: string | null,
    },
    bidAmount: string,
    offerAmount: string,
    benchmark?: Benchmark | null,
    spreadToBenchmark: string,
    accruedDays: string,
    accruedInterest: string,
    timezone: string,
    interpolatedCDRate: string,
    industry: string,
    esgScore: string,
    couponFrequency: string,
    makeWholeCall?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBondMutationVariables = {
  input: UpdateBondInput,
  condition?: ModelBondConditionInput | null,
};

export type UpdateBondMutation = {
  updateBond?:  {
    __typename: "Bond",
    id: string,
    // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
    cusip: string,
    isin: string,
    currency: Currency,
    issuerId: string,
    issuer:  {
      __typename: "Issuer",
      id: string,
      name: string,
      ticker: string,
      createdAt: string,
      updatedAt: string,
    },
    couponPayment: string,
    outstandingAmount: string,
    minimumPiece: string,
    minimumIncrement: string,
    isSecRegisteredSecurity: boolean,
    ratings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    callDates?:  Array< {
      __typename: "BondCallDate",
      price: string,
      callDate: string,
    } | null > | null,
    paymentRank: string,
    couponType: CouponType,
    maturity:  {
      __typename: "Maturity",
      date: string,
      maturityType: MaturityType,
      nextCallDate?: string | null,
      nextCallPrice?: string | null,
    },
    bidAmount: string,
    offerAmount: string,
    benchmark?: Benchmark | null,
    spreadToBenchmark: string,
    accruedDays: string,
    accruedInterest: string,
    timezone: string,
    interpolatedCDRate: string,
    industry: string,
    esgScore: string,
    couponFrequency: string,
    makeWholeCall?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBondMutationVariables = {
  input: DeleteBondInput,
  condition?: ModelBondConditionInput | null,
};

export type DeleteBondMutation = {
  deleteBond?:  {
    __typename: "Bond",
    id: string,
    // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
    cusip: string,
    isin: string,
    currency: Currency,
    issuerId: string,
    issuer:  {
      __typename: "Issuer",
      id: string,
      name: string,
      ticker: string,
      createdAt: string,
      updatedAt: string,
    },
    couponPayment: string,
    outstandingAmount: string,
    minimumPiece: string,
    minimumIncrement: string,
    isSecRegisteredSecurity: boolean,
    ratings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    callDates?:  Array< {
      __typename: "BondCallDate",
      price: string,
      callDate: string,
    } | null > | null,
    paymentRank: string,
    couponType: CouponType,
    maturity:  {
      __typename: "Maturity",
      date: string,
      maturityType: MaturityType,
      nextCallDate?: string | null,
      nextCallPrice?: string | null,
    },
    bidAmount: string,
    offerAmount: string,
    benchmark?: Benchmark | null,
    spreadToBenchmark: string,
    accruedDays: string,
    accruedInterest: string,
    timezone: string,
    interpolatedCDRate: string,
    industry: string,
    esgScore: string,
    couponFrequency: string,
    makeWholeCall?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateIssuerMutationVariables = {
  input: CreateIssuerInput,
  condition?: ModelIssuerConditionInput | null,
};

export type CreateIssuerMutation = {
  createIssuer?:  {
    __typename: "Issuer",
    id: string,
    name: string,
    ticker: string,
    bonds?:  {
      __typename: "ModelBondConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateIssuerMutationVariables = {
  input: UpdateIssuerInput,
  condition?: ModelIssuerConditionInput | null,
};

export type UpdateIssuerMutation = {
  updateIssuer?:  {
    __typename: "Issuer",
    id: string,
    name: string,
    ticker: string,
    bonds?:  {
      __typename: "ModelBondConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteIssuerMutationVariables = {
  input: DeleteIssuerInput,
  condition?: ModelIssuerConditionInput | null,
};

export type DeleteIssuerMutation = {
  deleteIssuer?:  {
    __typename: "Issuer",
    id: string,
    name: string,
    ticker: string,
    bonds?:  {
      __typename: "ModelBondConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBondRatingMutationVariables = {
  input: CreateBondRatingInput,
  condition?: ModelBondRatingConditionInput | null,
};

export type CreateBondRatingMutation = {
  createBondRating?:  {
    __typename: "BondRating",
    id: string,
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    ratingId: string,
    rating:  {
      __typename: "Rating",
      id: string,
      value: string,
      order: number,
      agencyId: string,
      createdAt: string,
      updatedAt: string,
    },
    watch?: RatingWatch | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBondRatingMutationVariables = {
  input: UpdateBondRatingInput,
  condition?: ModelBondRatingConditionInput | null,
};

export type UpdateBondRatingMutation = {
  updateBondRating?:  {
    __typename: "BondRating",
    id: string,
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    ratingId: string,
    rating:  {
      __typename: "Rating",
      id: string,
      value: string,
      order: number,
      agencyId: string,
      createdAt: string,
      updatedAt: string,
    },
    watch?: RatingWatch | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBondRatingMutationVariables = {
  input: DeleteBondRatingInput,
  condition?: ModelBondRatingConditionInput | null,
};

export type DeleteBondRatingMutation = {
  deleteBondRating?:  {
    __typename: "BondRating",
    id: string,
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    ratingId: string,
    rating:  {
      __typename: "Rating",
      id: string,
      value: string,
      order: number,
      agencyId: string,
      createdAt: string,
      updatedAt: string,
    },
    watch?: RatingWatch | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRatingMutationVariables = {
  input: CreateRatingInput,
  condition?: ModelRatingConditionInput | null,
};

export type CreateRatingMutation = {
  createRating?:  {
    __typename: "Rating",
    id: string,
    value: string,
    order: number,
    agencyId: string,
    agency:  {
      __typename: "RatingAgency",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    bondRatings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRatingMutationVariables = {
  input: UpdateRatingInput,
  condition?: ModelRatingConditionInput | null,
};

export type UpdateRatingMutation = {
  updateRating?:  {
    __typename: "Rating",
    id: string,
    value: string,
    order: number,
    agencyId: string,
    agency:  {
      __typename: "RatingAgency",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    bondRatings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRatingMutationVariables = {
  input: DeleteRatingInput,
  condition?: ModelRatingConditionInput | null,
};

export type DeleteRatingMutation = {
  deleteRating?:  {
    __typename: "Rating",
    id: string,
    value: string,
    order: number,
    agencyId: string,
    agency:  {
      __typename: "RatingAgency",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    bondRatings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRatingAgencyMutationVariables = {
  input: CreateRatingAgencyInput,
  condition?: ModelRatingAgencyConditionInput | null,
};

export type CreateRatingAgencyMutation = {
  createRatingAgency?:  {
    __typename: "RatingAgency",
    id: string,
    name: string,
    ratings?:  {
      __typename: "ModelRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRatingAgencyMutationVariables = {
  input: UpdateRatingAgencyInput,
  condition?: ModelRatingAgencyConditionInput | null,
};

export type UpdateRatingAgencyMutation = {
  updateRatingAgency?:  {
    __typename: "RatingAgency",
    id: string,
    name: string,
    ratings?:  {
      __typename: "ModelRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRatingAgencyMutationVariables = {
  input: DeleteRatingAgencyInput,
  condition?: ModelRatingAgencyConditionInput | null,
};

export type DeleteRatingAgencyMutation = {
  deleteRatingAgency?:  {
    __typename: "RatingAgency",
    id: string,
    name: string,
    ratings?:  {
      __typename: "ModelRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBondsPricesQuery = {
  listBondsPrices?:  {
    __typename: "BondPriceResponse",
    updatedAt: string,
    bondPrices?:  Array< {
      __typename: "BondPrice",
      bondId: string,
      bidPrice: string,
      askPrice: string,
      gSpread: string,
      bidGSpread: string,
      yieldAndSpreadBondYield: string,
      bidYield: string,
    } | null > | null,
  } | null,
};

export type BondSettlementDateQueryVariables = {
  input: BondSettlementDateInput,
};

export type BondSettlementDateQuery = {
  bondSettlementDate?:  {
    __typename: "BondSettlementDateResponse",
    settledAt: string,
  } | null,
};

export type GetAccountQueryVariables = {
  id: string,
};

export type GetAccountQuery = {
  getAccount?:  {
    __typename: "Account",
    id: string,
    owners: Array< string | null >,
    users?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    balanceAccounts?:  {
      __typename: "ModelBalanceAccountConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAccountsQueryVariables = {
  filter?: ModelAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAccountsQuery = {
  listAccounts?:  {
    __typename: "ModelAccountConnection",
    items:  Array< {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAccountHasUserQueryVariables = {
  id: string,
};

export type GetAccountHasUserQuery = {
  getAccountHasUser?:  {
    __typename: "AccountHasUser",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    userId: string,
    user:  {
      __typename: "User",
      id: string,
      stripeId?: string | null,
      favoriteBonds: Array< string >,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAccountHasUsersQueryVariables = {
  filter?: ModelAccountHasUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAccountHasUsersQuery = {
  listAccountHasUsers?:  {
    __typename: "ModelAccountHasUserConnection",
    items:  Array< {
      __typename: "AccountHasUser",
      id: string,
      accountId: string,
      userId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    accounts?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    stripeId?: string | null,
    favoriteBonds: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      stripeId?: string | null,
      favoriteBonds: Array< string >,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBalanceAccountQueryVariables = {
  id: string,
};

export type GetBalanceAccountQuery = {
  getBalanceAccount?:  {
    __typename: "BalanceAccount",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    currency?: Currency | null,
    bondId?: string | null,
    bond?:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactions?:  {
      __typename: "ModelTransactionConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBalanceAccountsQueryVariables = {
  filter?: ModelBalanceAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBalanceAccountsQuery = {
  listBalanceAccounts?:  {
    __typename: "ModelBalanceAccountConnection",
    items:  Array< {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTransactionQueryVariables = {
  id: string,
};

export type GetTransactionQuery = {
  getTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountId: string,
    previousTransactionId?: string | null,
    order: number,
    transactedAt: string,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    source?: TransactionSource | null,
    type: TransactionType,
    amountChange: string,
    disponibleAmountChange: string,
    orderTicketId?: string | null,
    orderTicket?:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    tradeTicketId?: string | null,
    tradeTicket?:  {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    complementaryTransactionId?: string | null,
    balance: string,
    disponibleBalance: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTransactionsQueryVariables = {
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionsQuery = {
  listTransactions?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      accountId: string,
      previousTransactionId?: string | null,
      order: number,
      transactedAt: string,
      balanceAccountId: string,
      source?: TransactionSource | null,
      type: TransactionType,
      amountChange: string,
      disponibleAmountChange: string,
      orderTicketId?: string | null,
      tradeTicketId?: string | null,
      complementaryTransactionId?: string | null,
      balance: string,
      disponibleBalance: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTradeTicketQueryVariables = {
  id: string,
};

export type GetTradeTicketQuery = {
  getTradeTicket?:  {
    __typename: "TradeTicket",
    id: string,
    accountId: string,
    orderTicketId: string,
    orderTicket:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    },
    amount: string,
    bondPrice: string,
    accruedDays: number,
    accruedInterest: string,
    tradeDate: string,
    settlementDate: string,
    closingOrderTickets?:  {
      __typename: "ModelOrderTicketConnection",
      nextToken?: string | null,
    } | null,
    isClosed?: boolean | null,
    finalCommissionAmount: string,
    loadedYield: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTradeTicketsQueryVariables = {
  filter?: ModelTradeTicketFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTradeTicketsQuery = {
  listTradeTickets?:  {
    __typename: "ModelTradeTicketConnection",
    items:  Array< {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrderTicketQueryVariables = {
  id: string,
};

export type GetOrderTicketQuery = {
  getOrderTicket?:  {
    __typename: "OrderTicket",
    id: string,
    accountId: string,
    direction: OrderDirection,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    faceAmount: string,
    bondPrice: string,
    minimumFillSize: string,
    status: OrderStatus,
    statusLastChangeByUserId?: string | null,
    cancelReason?: CancelReason | null,
    isConfirmed: boolean,
    confirmedByTraderId?: string | null,
    confirmedAt?: string | null,
    closingTradeTicketId?: string | null,
    tradeTickets?:  {
      __typename: "ModelTradeTicketConnection",
      nextToken?: string | null,
    } | null,
    appliedCommissionRate?:  {
      __typename: "RateCommissionType",
      amount: string,
      rate: string,
    } | null,
    loadedYield: string,
    isImmediate?: boolean | null,
    timeInForce?: TimeInForce | null,
    expiresAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrderTicketsQueryVariables = {
  filter?: ModelOrderTicketFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderTicketsQuery = {
  listOrderTickets?:  {
    __typename: "ModelOrderTicketConnection",
    items:  Array< {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRateCommissionQueryVariables = {
  id: string,
};

export type GetRateCommissionQuery = {
  getRateCommission?:  {
    __typename: "RateCommission",
    id: string,
    currency: Currency,
    amount: string,
    rate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRateCommissionsQueryVariables = {
  filter?: ModelRateCommissionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRateCommissionsQuery = {
  listRateCommissions?:  {
    __typename: "ModelRateCommissionConnection",
    items:  Array< {
      __typename: "RateCommission",
      id: string,
      currency: Currency,
      amount: string,
      rate: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBondQueryVariables = {
  id: string,
};

export type GetBondQuery = {
  getBond?:  {
    __typename: "Bond",
    id: string,
    // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
    cusip: string,
    isin: string,
    currency: Currency,
    issuerId: string,
    issuer:  {
      __typename: "Issuer",
      id: string,
      name: string,
      ticker: string,
      createdAt: string,
      updatedAt: string,
    },
    couponPayment: string,
    outstandingAmount: string,
    minimumPiece: string,
    minimumIncrement: string,
    isSecRegisteredSecurity: boolean,
    ratings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    callDates?:  Array< {
      __typename: "BondCallDate",
      price: string,
      callDate: string,
    } | null > | null,
    paymentRank: string,
    couponType: CouponType,
    maturity:  {
      __typename: "Maturity",
      date: string,
      maturityType: MaturityType,
      nextCallDate?: string | null,
      nextCallPrice?: string | null,
    },
    bidAmount: string,
    offerAmount: string,
    benchmark?: Benchmark | null,
    spreadToBenchmark: string,
    accruedDays: string,
    accruedInterest: string,
    timezone: string,
    interpolatedCDRate: string,
    industry: string,
    esgScore: string,
    couponFrequency: string,
    makeWholeCall?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBondsQueryVariables = {
  filter?: ModelBondFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBondsQuery = {
  listBonds?:  {
    __typename: "ModelBondConnection",
    items:  Array< {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIssuerQueryVariables = {
  id: string,
};

export type GetIssuerQuery = {
  getIssuer?:  {
    __typename: "Issuer",
    id: string,
    name: string,
    ticker: string,
    bonds?:  {
      __typename: "ModelBondConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListIssuersQueryVariables = {
  filter?: ModelIssuerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIssuersQuery = {
  listIssuers?:  {
    __typename: "ModelIssuerConnection",
    items:  Array< {
      __typename: "Issuer",
      id: string,
      name: string,
      ticker: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBondRatingQueryVariables = {
  id: string,
};

export type GetBondRatingQuery = {
  getBondRating?:  {
    __typename: "BondRating",
    id: string,
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    ratingId: string,
    rating:  {
      __typename: "Rating",
      id: string,
      value: string,
      order: number,
      agencyId: string,
      createdAt: string,
      updatedAt: string,
    },
    watch?: RatingWatch | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBondRatingsQueryVariables = {
  filter?: ModelBondRatingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBondRatingsQuery = {
  listBondRatings?:  {
    __typename: "ModelBondRatingConnection",
    items:  Array< {
      __typename: "BondRating",
      id: string,
      bondId: string,
      ratingId: string,
      watch?: RatingWatch | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRatingQueryVariables = {
  id: string,
};

export type GetRatingQuery = {
  getRating?:  {
    __typename: "Rating",
    id: string,
    value: string,
    order: number,
    agencyId: string,
    agency:  {
      __typename: "RatingAgency",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    bondRatings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRatingsQueryVariables = {
  filter?: ModelRatingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRatingsQuery = {
  listRatings?:  {
    __typename: "ModelRatingConnection",
    items:  Array< {
      __typename: "Rating",
      id: string,
      value: string,
      order: number,
      agencyId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRatingAgencyQueryVariables = {
  id: string,
};

export type GetRatingAgencyQuery = {
  getRatingAgency?:  {
    __typename: "RatingAgency",
    id: string,
    name: string,
    ratings?:  {
      __typename: "ModelRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRatingAgencysQueryVariables = {
  filter?: ModelRatingAgencyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRatingAgencysQuery = {
  listRatingAgencys?:  {
    __typename: "ModelRatingAgencyConnection",
    items:  Array< {
      __typename: "RatingAgency",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTransactionsByBalanceAccountSortedByOrderQueryVariables = {
  balanceAccountId?: string | null,
  order?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionsByBalanceAccountSortedByOrderQuery = {
  listTransactionsByBalanceAccountSortedByOrder?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      accountId: string,
      previousTransactionId?: string | null,
      order: number,
      transactedAt: string,
      balanceAccountId: string,
      source?: TransactionSource | null,
      type: TransactionType,
      amountChange: string,
      disponibleAmountChange: string,
      orderTicketId?: string | null,
      tradeTicketId?: string | null,
      complementaryTransactionId?: string | null,
      balance: string,
      disponibleBalance: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ObserveBondSubscription = {
  observeBond?:  {
    __typename: "Bond",
    id: string,
    // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
    cusip: string,
    isin: string,
    currency: Currency,
    issuerId: string,
    issuer:  {
      __typename: "Issuer",
      id: string,
      name: string,
      ticker: string,
      createdAt: string,
      updatedAt: string,
    },
    couponPayment: string,
    outstandingAmount: string,
    minimumPiece: string,
    minimumIncrement: string,
    isSecRegisteredSecurity: boolean,
    ratings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    callDates?:  Array< {
      __typename: "BondCallDate",
      price: string,
      callDate: string,
    } | null > | null,
    paymentRank: string,
    couponType: CouponType,
    maturity:  {
      __typename: "Maturity",
      date: string,
      maturityType: MaturityType,
      nextCallDate?: string | null,
      nextCallPrice?: string | null,
    },
    bidAmount: string,
    offerAmount: string,
    benchmark?: Benchmark | null,
    spreadToBenchmark: string,
    accruedDays: string,
    accruedInterest: string,
    timezone: string,
    interpolatedCDRate: string,
    industry: string,
    esgScore: string,
    couponFrequency: string,
    makeWholeCall?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ObserveBondRatingSubscription = {
  observeBondRating?:  {
    __typename: "BondRating",
    id: string,
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    ratingId: string,
    rating:  {
      __typename: "Rating",
      id: string,
      value: string,
      order: number,
      agencyId: string,
      createdAt: string,
      updatedAt: string,
    },
    watch?: RatingWatch | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ObserveIssuerSubscription = {
  observeIssuer?:  {
    __typename: "Issuer",
    id: string,
    name: string,
    ticker: string,
    bonds?:  {
      __typename: "ModelBondConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ObserveUserSubscription = {
  observeUser?:  {
    __typename: "User",
    id: string,
    accounts?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    stripeId?: string | null,
    favoriteBonds: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ObserveAccountSubscription = {
  observeAccount?:  {
    __typename: "Account",
    id: string,
    owners: Array< string | null >,
    users?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    balanceAccounts?:  {
      __typename: "ModelBalanceAccountConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ObserveBalanceAccountSubscription = {
  observeBalanceAccount?:  {
    __typename: "BalanceAccount",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    currency?: Currency | null,
    bondId?: string | null,
    bond?:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactions?:  {
      __typename: "ModelTransactionConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ObserveTransactionSubscription = {
  observeTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountId: string,
    previousTransactionId?: string | null,
    order: number,
    transactedAt: string,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    source?: TransactionSource | null,
    type: TransactionType,
    amountChange: string,
    disponibleAmountChange: string,
    orderTicketId?: string | null,
    orderTicket?:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    tradeTicketId?: string | null,
    tradeTicket?:  {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    complementaryTransactionId?: string | null,
    balance: string,
    disponibleBalance: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAccountSubscriptionVariables = {
  owners?: string | null,
};

export type OnCreateAccountSubscription = {
  onCreateAccount?:  {
    __typename: "Account",
    id: string,
    owners: Array< string | null >,
    users?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    balanceAccounts?:  {
      __typename: "ModelBalanceAccountConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAccountSubscriptionVariables = {
  owners?: string | null,
};

export type OnUpdateAccountSubscription = {
  onUpdateAccount?:  {
    __typename: "Account",
    id: string,
    owners: Array< string | null >,
    users?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    balanceAccounts?:  {
      __typename: "ModelBalanceAccountConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAccountSubscriptionVariables = {
  owners?: string | null,
};

export type OnDeleteAccountSubscription = {
  onDeleteAccount?:  {
    __typename: "Account",
    id: string,
    owners: Array< string | null >,
    users?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    balanceAccounts?:  {
      __typename: "ModelBalanceAccountConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAccountHasUserSubscriptionVariables = {
  userId?: string | null,
};

export type OnCreateAccountHasUserSubscription = {
  onCreateAccountHasUser?:  {
    __typename: "AccountHasUser",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    userId: string,
    user:  {
      __typename: "User",
      id: string,
      stripeId?: string | null,
      favoriteBonds: Array< string >,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAccountHasUserSubscriptionVariables = {
  userId?: string | null,
};

export type OnUpdateAccountHasUserSubscription = {
  onUpdateAccountHasUser?:  {
    __typename: "AccountHasUser",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    userId: string,
    user:  {
      __typename: "User",
      id: string,
      stripeId?: string | null,
      favoriteBonds: Array< string >,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAccountHasUserSubscriptionVariables = {
  userId?: string | null,
};

export type OnDeleteAccountHasUserSubscription = {
  onDeleteAccountHasUser?:  {
    __typename: "AccountHasUser",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    userId: string,
    user:  {
      __typename: "User",
      id: string,
      stripeId?: string | null,
      favoriteBonds: Array< string >,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  id?: string | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    accounts?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    stripeId?: string | null,
    favoriteBonds: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  id?: string | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    accounts?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    stripeId?: string | null,
    favoriteBonds: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  id?: string | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    accounts?:  {
      __typename: "ModelAccountHasUserConnection",
      nextToken?: string | null,
    } | null,
    stripeId?: string | null,
    favoriteBonds: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBalanceAccountSubscription = {
  onCreateBalanceAccount?:  {
    __typename: "BalanceAccount",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    currency?: Currency | null,
    bondId?: string | null,
    bond?:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactions?:  {
      __typename: "ModelTransactionConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBalanceAccountSubscription = {
  onUpdateBalanceAccount?:  {
    __typename: "BalanceAccount",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    currency?: Currency | null,
    bondId?: string | null,
    bond?:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactions?:  {
      __typename: "ModelTransactionConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBalanceAccountSubscription = {
  onDeleteBalanceAccount?:  {
    __typename: "BalanceAccount",
    id: string,
    accountId: string,
    account:  {
      __typename: "Account",
      id: string,
      owners: Array< string | null >,
      createdAt: string,
      updatedAt: string,
    },
    currency?: Currency | null,
    bondId?: string | null,
    bond?:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    transactions?:  {
      __typename: "ModelTransactionConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTransactionSubscription = {
  onCreateTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountId: string,
    previousTransactionId?: string | null,
    order: number,
    transactedAt: string,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    source?: TransactionSource | null,
    type: TransactionType,
    amountChange: string,
    disponibleAmountChange: string,
    orderTicketId?: string | null,
    orderTicket?:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    tradeTicketId?: string | null,
    tradeTicket?:  {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    complementaryTransactionId?: string | null,
    balance: string,
    disponibleBalance: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTransactionSubscription = {
  onUpdateTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountId: string,
    previousTransactionId?: string | null,
    order: number,
    transactedAt: string,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    source?: TransactionSource | null,
    type: TransactionType,
    amountChange: string,
    disponibleAmountChange: string,
    orderTicketId?: string | null,
    orderTicket?:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    tradeTicketId?: string | null,
    tradeTicket?:  {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    complementaryTransactionId?: string | null,
    balance: string,
    disponibleBalance: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTransactionSubscription = {
  onDeleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountId: string,
    previousTransactionId?: string | null,
    order: number,
    transactedAt: string,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    source?: TransactionSource | null,
    type: TransactionType,
    amountChange: string,
    disponibleAmountChange: string,
    orderTicketId?: string | null,
    orderTicket?:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    tradeTicketId?: string | null,
    tradeTicket?:  {
      __typename: "TradeTicket",
      id: string,
      accountId: string,
      orderTicketId: string,
      amount: string,
      bondPrice: string,
      accruedDays: number,
      accruedInterest: string,
      tradeDate: string,
      settlementDate: string,
      isClosed?: boolean | null,
      finalCommissionAmount: string,
      loadedYield: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    complementaryTransactionId?: string | null,
    balance: string,
    disponibleBalance: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTradeTicketSubscription = {
  onCreateTradeTicket?:  {
    __typename: "TradeTicket",
    id: string,
    accountId: string,
    orderTicketId: string,
    orderTicket:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    },
    amount: string,
    bondPrice: string,
    accruedDays: number,
    accruedInterest: string,
    tradeDate: string,
    settlementDate: string,
    closingOrderTickets?:  {
      __typename: "ModelOrderTicketConnection",
      nextToken?: string | null,
    } | null,
    isClosed?: boolean | null,
    finalCommissionAmount: string,
    loadedYield: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTradeTicketSubscription = {
  onUpdateTradeTicket?:  {
    __typename: "TradeTicket",
    id: string,
    accountId: string,
    orderTicketId: string,
    orderTicket:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    },
    amount: string,
    bondPrice: string,
    accruedDays: number,
    accruedInterest: string,
    tradeDate: string,
    settlementDate: string,
    closingOrderTickets?:  {
      __typename: "ModelOrderTicketConnection",
      nextToken?: string | null,
    } | null,
    isClosed?: boolean | null,
    finalCommissionAmount: string,
    loadedYield: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTradeTicketSubscription = {
  onDeleteTradeTicket?:  {
    __typename: "TradeTicket",
    id: string,
    accountId: string,
    orderTicketId: string,
    orderTicket:  {
      __typename: "OrderTicket",
      id: string,
      accountId: string,
      direction: OrderDirection,
      balanceAccountId: string,
      bondId: string,
      faceAmount: string,
      bondPrice: string,
      minimumFillSize: string,
      status: OrderStatus,
      statusLastChangeByUserId?: string | null,
      cancelReason?: CancelReason | null,
      isConfirmed: boolean,
      confirmedByTraderId?: string | null,
      confirmedAt?: string | null,
      closingTradeTicketId?: string | null,
      loadedYield: string,
      isImmediate?: boolean | null,
      timeInForce?: TimeInForce | null,
      expiresAt: string,
      createdAt: string,
      updatedAt: string,
    },
    amount: string,
    bondPrice: string,
    accruedDays: number,
    accruedInterest: string,
    tradeDate: string,
    settlementDate: string,
    closingOrderTickets?:  {
      __typename: "ModelOrderTicketConnection",
      nextToken?: string | null,
    } | null,
    isClosed?: boolean | null,
    finalCommissionAmount: string,
    loadedYield: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrderTicketSubscription = {
  onCreateOrderTicket?:  {
    __typename: "OrderTicket",
    id: string,
    accountId: string,
    direction: OrderDirection,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    faceAmount: string,
    bondPrice: string,
    minimumFillSize: string,
    status: OrderStatus,
    statusLastChangeByUserId?: string | null,
    cancelReason?: CancelReason | null,
    isConfirmed: boolean,
    confirmedByTraderId?: string | null,
    confirmedAt?: string | null,
    closingTradeTicketId?: string | null,
    tradeTickets?:  {
      __typename: "ModelTradeTicketConnection",
      nextToken?: string | null,
    } | null,
    appliedCommissionRate?:  {
      __typename: "RateCommissionType",
      amount: string,
      rate: string,
    } | null,
    loadedYield: string,
    isImmediate?: boolean | null,
    timeInForce?: TimeInForce | null,
    expiresAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrderTicketSubscription = {
  onUpdateOrderTicket?:  {
    __typename: "OrderTicket",
    id: string,
    accountId: string,
    direction: OrderDirection,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    faceAmount: string,
    bondPrice: string,
    minimumFillSize: string,
    status: OrderStatus,
    statusLastChangeByUserId?: string | null,
    cancelReason?: CancelReason | null,
    isConfirmed: boolean,
    confirmedByTraderId?: string | null,
    confirmedAt?: string | null,
    closingTradeTicketId?: string | null,
    tradeTickets?:  {
      __typename: "ModelTradeTicketConnection",
      nextToken?: string | null,
    } | null,
    appliedCommissionRate?:  {
      __typename: "RateCommissionType",
      amount: string,
      rate: string,
    } | null,
    loadedYield: string,
    isImmediate?: boolean | null,
    timeInForce?: TimeInForce | null,
    expiresAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrderTicketSubscription = {
  onDeleteOrderTicket?:  {
    __typename: "OrderTicket",
    id: string,
    accountId: string,
    direction: OrderDirection,
    balanceAccountId: string,
    balanceAccount:  {
      __typename: "BalanceAccount",
      id: string,
      accountId: string,
      currency?: Currency | null,
      bondId?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    faceAmount: string,
    bondPrice: string,
    minimumFillSize: string,
    status: OrderStatus,
    statusLastChangeByUserId?: string | null,
    cancelReason?: CancelReason | null,
    isConfirmed: boolean,
    confirmedByTraderId?: string | null,
    confirmedAt?: string | null,
    closingTradeTicketId?: string | null,
    tradeTickets?:  {
      __typename: "ModelTradeTicketConnection",
      nextToken?: string | null,
    } | null,
    appliedCommissionRate?:  {
      __typename: "RateCommissionType",
      amount: string,
      rate: string,
    } | null,
    loadedYield: string,
    isImmediate?: boolean | null,
    timeInForce?: TimeInForce | null,
    expiresAt: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRateCommissionSubscription = {
  onCreateRateCommission?:  {
    __typename: "RateCommission",
    id: string,
    currency: Currency,
    amount: string,
    rate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRateCommissionSubscription = {
  onUpdateRateCommission?:  {
    __typename: "RateCommission",
    id: string,
    currency: Currency,
    amount: string,
    rate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRateCommissionSubscription = {
  onDeleteRateCommission?:  {
    __typename: "RateCommission",
    id: string,
    currency: Currency,
    amount: string,
    rate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBondSubscription = {
  onCreateBond?:  {
    __typename: "Bond",
    id: string,
    // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
    cusip: string,
    isin: string,
    currency: Currency,
    issuerId: string,
    issuer:  {
      __typename: "Issuer",
      id: string,
      name: string,
      ticker: string,
      createdAt: string,
      updatedAt: string,
    },
    couponPayment: string,
    outstandingAmount: string,
    minimumPiece: string,
    minimumIncrement: string,
    isSecRegisteredSecurity: boolean,
    ratings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    callDates?:  Array< {
      __typename: "BondCallDate",
      price: string,
      callDate: string,
    } | null > | null,
    paymentRank: string,
    couponType: CouponType,
    maturity:  {
      __typename: "Maturity",
      date: string,
      maturityType: MaturityType,
      nextCallDate?: string | null,
      nextCallPrice?: string | null,
    },
    bidAmount: string,
    offerAmount: string,
    benchmark?: Benchmark | null,
    spreadToBenchmark: string,
    accruedDays: string,
    accruedInterest: string,
    timezone: string,
    interpolatedCDRate: string,
    industry: string,
    esgScore: string,
    couponFrequency: string,
    makeWholeCall?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBondSubscription = {
  onUpdateBond?:  {
    __typename: "Bond",
    id: string,
    // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
    cusip: string,
    isin: string,
    currency: Currency,
    issuerId: string,
    issuer:  {
      __typename: "Issuer",
      id: string,
      name: string,
      ticker: string,
      createdAt: string,
      updatedAt: string,
    },
    couponPayment: string,
    outstandingAmount: string,
    minimumPiece: string,
    minimumIncrement: string,
    isSecRegisteredSecurity: boolean,
    ratings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    callDates?:  Array< {
      __typename: "BondCallDate",
      price: string,
      callDate: string,
    } | null > | null,
    paymentRank: string,
    couponType: CouponType,
    maturity:  {
      __typename: "Maturity",
      date: string,
      maturityType: MaturityType,
      nextCallDate?: string | null,
      nextCallPrice?: string | null,
    },
    bidAmount: string,
    offerAmount: string,
    benchmark?: Benchmark | null,
    spreadToBenchmark: string,
    accruedDays: string,
    accruedInterest: string,
    timezone: string,
    interpolatedCDRate: string,
    industry: string,
    esgScore: string,
    couponFrequency: string,
    makeWholeCall?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBondSubscription = {
  onDeleteBond?:  {
    __typename: "Bond",
    id: string,
    // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
    cusip: string,
    isin: string,
    currency: Currency,
    issuerId: string,
    issuer:  {
      __typename: "Issuer",
      id: string,
      name: string,
      ticker: string,
      createdAt: string,
      updatedAt: string,
    },
    couponPayment: string,
    outstandingAmount: string,
    minimumPiece: string,
    minimumIncrement: string,
    isSecRegisteredSecurity: boolean,
    ratings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    callDates?:  Array< {
      __typename: "BondCallDate",
      price: string,
      callDate: string,
    } | null > | null,
    paymentRank: string,
    couponType: CouponType,
    maturity:  {
      __typename: "Maturity",
      date: string,
      maturityType: MaturityType,
      nextCallDate?: string | null,
      nextCallPrice?: string | null,
    },
    bidAmount: string,
    offerAmount: string,
    benchmark?: Benchmark | null,
    spreadToBenchmark: string,
    accruedDays: string,
    accruedInterest: string,
    timezone: string,
    interpolatedCDRate: string,
    industry: string,
    esgScore: string,
    couponFrequency: string,
    makeWholeCall?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateIssuerSubscription = {
  onCreateIssuer?:  {
    __typename: "Issuer",
    id: string,
    name: string,
    ticker: string,
    bonds?:  {
      __typename: "ModelBondConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateIssuerSubscription = {
  onUpdateIssuer?:  {
    __typename: "Issuer",
    id: string,
    name: string,
    ticker: string,
    bonds?:  {
      __typename: "ModelBondConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteIssuerSubscription = {
  onDeleteIssuer?:  {
    __typename: "Issuer",
    id: string,
    name: string,
    ticker: string,
    bonds?:  {
      __typename: "ModelBondConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBondRatingSubscription = {
  onCreateBondRating?:  {
    __typename: "BondRating",
    id: string,
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    ratingId: string,
    rating:  {
      __typename: "Rating",
      id: string,
      value: string,
      order: number,
      agencyId: string,
      createdAt: string,
      updatedAt: string,
    },
    watch?: RatingWatch | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBondRatingSubscription = {
  onUpdateBondRating?:  {
    __typename: "BondRating",
    id: string,
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    ratingId: string,
    rating:  {
      __typename: "Rating",
      id: string,
      value: string,
      order: number,
      agencyId: string,
      createdAt: string,
      updatedAt: string,
    },
    watch?: RatingWatch | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBondRatingSubscription = {
  onDeleteBondRating?:  {
    __typename: "BondRating",
    id: string,
    bondId: string,
    bond:  {
      __typename: "Bond",
      id: string,
      // Unique identification number assigned to all stocks and registered bonds in the United States and Canada
      cusip: string,
      isin: string,
      currency: Currency,
      issuerId: string,
      couponPayment: string,
      outstandingAmount: string,
      minimumPiece: string,
      minimumIncrement: string,
      isSecRegisteredSecurity: boolean,
      paymentRank: string,
      couponType: CouponType,
      bidAmount: string,
      offerAmount: string,
      benchmark?: Benchmark | null,
      spreadToBenchmark: string,
      accruedDays: string,
      accruedInterest: string,
      timezone: string,
      interpolatedCDRate: string,
      industry: string,
      esgScore: string,
      couponFrequency: string,
      makeWholeCall?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    ratingId: string,
    rating:  {
      __typename: "Rating",
      id: string,
      value: string,
      order: number,
      agencyId: string,
      createdAt: string,
      updatedAt: string,
    },
    watch?: RatingWatch | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRatingSubscription = {
  onCreateRating?:  {
    __typename: "Rating",
    id: string,
    value: string,
    order: number,
    agencyId: string,
    agency:  {
      __typename: "RatingAgency",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    bondRatings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRatingSubscription = {
  onUpdateRating?:  {
    __typename: "Rating",
    id: string,
    value: string,
    order: number,
    agencyId: string,
    agency:  {
      __typename: "RatingAgency",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    bondRatings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRatingSubscription = {
  onDeleteRating?:  {
    __typename: "Rating",
    id: string,
    value: string,
    order: number,
    agencyId: string,
    agency:  {
      __typename: "RatingAgency",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    },
    bondRatings?:  {
      __typename: "ModelBondRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRatingAgencySubscription = {
  onCreateRatingAgency?:  {
    __typename: "RatingAgency",
    id: string,
    name: string,
    ratings?:  {
      __typename: "ModelRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRatingAgencySubscription = {
  onUpdateRatingAgency?:  {
    __typename: "RatingAgency",
    id: string,
    name: string,
    ratings?:  {
      __typename: "ModelRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRatingAgencySubscription = {
  onDeleteRatingAgency?:  {
    __typename: "RatingAgency",
    id: string,
    name: string,
    ratings?:  {
      __typename: "ModelRatingConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};
